<template>
  <div class="adjustment-add-container">
    
    <InfoContainer
      id="basicForm"
      :infoTitle="contentConfig['infoTitle']"
      :contentConfig="contentConfig['infoContent']"
    >
      <template #basicInfo>
        <avue-form ref="basicInfo" v-model="basicInfoData" :option="formConfig">
          <template #name>
            
            <!-- 存在绑定ID时不可更改项目 -->
            <CommonSelect
              :clearable="false"
              bindLabel="name"
              bindKey="id"
              bindValue="name"
              dataUrl="bl/blreportstandard/page"
              methods="get"
              dataMethod="params"
              searchKey="name"
              :initParam="initParam"
              :disabled="
                $route.params.id && $route.params.id != '' ? true : false
              "
              :bindId="basicInfoData.reportId ? basicInfoData.reportId : ''"
              @handleChange="setProjectInfo"
            />
          </template>

          <!-- 债权人和债务人选择 -->
          <template #sellerCustId>
            <CommonSelect
              bindLabel="custName"
              bindKey="id"
              bindValue="custName"
              methods="get"
              dataMethod="params"
              dataUrl="bl/custbasicinformationbl/page"
              :bindId="
                basicInfoData.sellerCustId ? basicInfoData.sellerCustId : ''
              "
              @handleChange="setSellerCustId"
            />
          </template>
          <template #buyerCustId>
            <CommonSelect
              bindLabel="dictValue"
              bindKey="dictKey"
              bindValue="dictValue"
              :disabled="true"
              dataUrl="/blade-/zd/custom/dict"
              :bindId="
                basicInfoData.buyerCustId ? basicInfoData.buyerCustId : ''
              "
              @handleChange="setBuyerCustId"
            />
          </template>
        </avue-form>
      </template>
    </InfoContainer>

    <!-- <InfoContainer
            id="basicForm"
            :infoTitle="interestConfig['infoTitle']"
            :contentConfig="interestConfig['infoContent']"
        >
            <template #basicInfo>

            </template>
        </InfoContainer>

        <InfoContainer
            id="basicForm"
            :infoTitle="rateConfig['infoTitle']"
            :contentConfig="rateConfig['infoContent']"
        >
            <template #basicInfo>

            </template>
        </InfoContainer>

        <InfoContainer
            id="basicForm"
            :infoTitle="rentConfig['infoTitle']"
            :contentConfig="rentConfig['infoContent']"
        >
            <template #basicInfo>

            </template>
        </InfoContainer>         -->

    <InfoContainer
      :infoTitle="fileConfig['infoTitle']"
      :contentConfig="fileConfig['infoContent']"
    >
      <template #fileInfo>
        
        <Accessory
          v-if="uploadPermissionNameOne != ''&&basicInfoData.projectInfoId"
          :idname="uploadPermissionNameTwo"
          :fileMenuUrlname="uploadPermissionNameOne"
          :projectid="basicInfoData.projectInfoId"
          :dynamicId="virtualId"
          :upload="true"
          :permissionList="permissionList"
          :isPermission="true"
        />
      </template>
    </InfoContainer>

    <InfoContainer
      :infoTitle="commentConfig['infoTitle']"
      :contentConfig="commentConfig['infoContent']"
    >
      <template #commentInfo>
        <!-- 会签意见区 -->
        <CommentBlock
          ref="commentBlock"
          :id="virtualId"
          @fileChange="fileChange"
        />
      </template>
    </InfoContainer>
    <div style="width: 100%; height: 40px"></div>
    <div class="bottom-container">
      <div class="button-container">
        <el-button type="primary" @click="validData(false)">保存</el-button>
        <el-button
          type="primary"
          plain
          @click="validData(true)"
          v-if="!basicInfoData.flowableId"
          >发起流程</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Accessory from "@/components/accessoriesother/accessoryFactor";
import CommonSelect from "@/components/commonSelect/commonSelect";
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import { addAdjustmentConfig } from "./adjustmentConfig.js";
import {
  addAdjustment,
  getPocessName,
  adjustmentDetail,
  queryAdjustmentNum,
} from "@/api/factoring/factoring";
import { mapGetters } from "vuex";
import workFlow from "@/mixins/workFlow";
export default {
  name: "AdjustmentAdd",
  mixins: [workFlow],
  data() {
    return {
      virtualId: "",
      processDefinedId: "",
      basicInfoData: {
        projectInfoId:''
      },
      // initParam: {listScene: 'tz'},
      initParam: { auditStatus: 2, listScene: "tz" },
      formConfig: addAdjustmentConfig(),
      processKey: "process_projectAdjustment",
      detailFormUrl: "/factoring/projectAdjustment/adjustmentDetail",
      contentConfig: {
        infoTitle: "新建项目调整",
        infoContent: [
          {
            title: "基础信息",
            prop: "basicInfo",
          },
        ],
      },
      interestConfig: {
        infoTitle: "批量调息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      rateConfig: {
        infoTitle: "利率变更",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      rentConfig: {
        infoTitle: "调整租金计划",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    Accessory,
    InfoContainer,
    CommentBlock,
    CommonSelect,
  },
  async mounted() {
    if (this.$route["params"]["id"]) {
      this.virtualId = this.$route["params"]["id"];
      this.queryAdjustmentDetail(this.virtualId);
    } else {
      this.virtualId = await this.getVirtualID();
    }
    this.getBasicConfigData();
    this.basicInfoData.managerUserName = this.userInfo.nick_name;
    this.basicInfoData.managerUser = this.userInfo.user_id;
  },
  methods: {
    async queryAdjustmentDetail(id) {
      let res = await adjustmentDetail({ id: id });
      if (res.data.code == 200) {
        this.basicInfoData = res.data.data;
      }
    },

    async getBasicConfigData() {
      this.processDefinedId = await this.userQueryProcessDefinedId(
        this.processKey
      );
      // 获取当前流程文件上传列表权限 permissionList
      this.permissionList = await this.queryTaskUploadDetail(
        this.processDefinedId,
        "",
        true
      );
      // 设置流程表单路径
      this.queryProcessFormDetail(this.processDefinedId);
    },

    // 设置选择的项目
    async setProjectInfo(data) {
      if (data !== "") {
        this.basicInfoData.name = data.name;
        this.basicInfoData.auditName = data.name;
        this.basicInfoData.number = data.number;
        // 赋值项目相关数据
        

        this.basicInfoData.reportId = data.id;

        this.basicInfoData.sellerCustId = data.sellerCustId;
        this.basicInfoData.sellerCustName = data.sellerCustName;
        this.basicInfoData.buyerCustName = data.buyerCustName;
        this.basicInfoData.projectType = `${data.projectType}`;
        this.basicInfoData.projectComeFrom = `${data.projectComeFrom}`;
        this.basicInfoData.factoringCredit = data.factoringCredit;
        this.basicInfoData.projectTypeStr = data.projectTypeStr;
        this.basicInfoData.accountingEntity = data.accountingEntity;

        // 设置协办数据
        this.basicInfoData.assistUserName = data.assistUserName;
        this.basicInfoData.assistUser = data.assistUser;


        this.basicInfoData.projectInfoId = data.projectInfoId;
        // 查询调整申请次数
        let adjustmentRes = await queryAdjustmentNum({
          projectInfoId: data.projectInfoId,
        });
        this.basicInfoData.adjustNumber = adjustmentRes.data.data;
        
        
      }
    },

    // 设置卖方信息
    setSellerCustId(data) {
      this.basicInfoData.sellerCustId = data.id;
      this.basicInfoData.sellerCustName = data.custName;
    },

    setBuyerCustId(data) {
      this.basicInfoData.buyerCustId = data.id;
      this.basicInfoData.buyerCustName = data.custName;
    },

    validData(startProcess) {
      let self = this;
      this.$refs.basicInfo.validate((valid, done) => {
        if (valid) {
          // 校验通过, 提交数据
          self.submitForm(startProcess);
          done();
        } else {
          let element = document.getElementById("basicForm");
          element.scrollIntoView();
          self.$message({
            type: "warning",
            message: "请补全基础信息数据",
          });
        }
      });
    },

    async submitForm(startProcess) {
      let processInsId = "";
      let params = {
        id: this.virtualId,
        flowableId: "",
        ...this.basicInfoData,
      };
      // let processNameRes = await getPocessName(params)
      if (startProcess) {
        // 若存在会签意见附件 带入attchment字段
        let redirectInfo = {
          url: this.detailFormUrl,
          id: this.virtualId,
        };
        let processParams = {
          detailFormUrl: JSON.stringify(redirectInfo),
          processId: this.processDefinedId,
          comment: this.$refs.commentBlock.$data.opinionContent,
          attachmentList: this.attchmentList,
          // processInstanceName: processNameRes.data.data.processInstanceName
        };
        processInsId = await this.startWorkFlowProcess(processParams);
      }
      if (processInsId != "") params.flowableId = processInsId;
      // 调整申请次数 +1
      params.adjustNumber++;
      let res = await addAdjustment(params);
      if (res.data.code == 200) {
        this.$router.push({
          path: `/factoring/projectAdjustment/adjustmentDetail/${this.virtualId}`,
        });
        this.$message({
          message: "项目调整申请成功",
          type: "success",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.adjustment-add-container {
  .submit-con {
    text-align: center;
    margin-bottom: 40px;
    button {
      width: 150px;
    }
  }
  .bottom-container {
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
    .button-container {
      width: 78%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>